import { render, staticRenderFns } from "./AboutUs2Page.vue?vue&type=template&id=13ff69ab&scoped=true"
import script from "./AboutUs2Page.vue?vue&type=script&lang=js"
export * from "./AboutUs2Page.vue?vue&type=script&lang=js"
import style0 from "./AboutUs2Page.vue?vue&type=style&index=0&id=13ff69ab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ff69ab",
  null
  
)

export default component.exports